import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';

import { QuillModule } from '../../vendor/ngx-quill/quill.module';
import { formlyConfig } from './formly.config';
import { FormlyFieldWysiwygComponent } from './formly-wysiwyg/wysiwyg.component';
export class NgxFormlyModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [FormsModule, ReactiveFormsModule, FormlyModule.forRoot(formlyConfig), FormlyBootstrapModule, QuillModule],
  exports: [FormlyModule],
  declarations: [FormlyFieldWysiwygComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxFormlyModule_tsickle_Closure_declarations() {
/** @type {?} */
NgxFormlyModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxFormlyModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
